import React, { useState } from "react";
import { ChildrenProps } from "../models/componentModel";
import { getTemplateDetails, createWhatsappTemplatePayload, } from "../models/axiosModel";
import agent from "../services/api";

const WhatsappTemplateContext = React.createContext<WhatsappTemplateContextPayload | undefined>(undefined);



export interface WhatsappTemplateContextPayload {
    templateList: getTemplateDetails[] | null,
    setTemplateList: React.Dispatch<React.SetStateAction<getTemplateDetails[] | null>>,

    getTemplateList: (meta_integration_whatsapp_id: number) => Promise<any>,

    flagImportTemplatePopup: boolean,
    setFlagImportTemplatePopup: React.Dispatch<React.SetStateAction<boolean>>,

    showLegacyImportPopup: boolean, // for legacy template info page
    setShowLegacyImportPopup: React.Dispatch<React.SetStateAction<boolean>>,

    importLegacyTemplatePayload: createWhatsappTemplatePayload | null;
    setImportLegacyTemplatePayload: (payload: createWhatsappTemplatePayload | null) => void;

    importLegacyTemplateName: string | null;
    setImportLegacyTemplateName: (name: string | null) => void;

    importLegacyTemplateJson: string | null;
    setImportLegacyTemplateJson: (json: string | null) => void;

    importLegacyTemplateFile: File | null;
    setImportLegacyTemplateFile: (file: File | null) => void;

    importLegacyTemplateFileName: string | null;
    setImportLegacyTemplateFileName: (name: string | null) => void;

    importLegacyTemplateSelectedTab: number;
    setImportLegacyTemplateSelectedTab: (tab: number) => void;

    sortTemplateList: (templateList: getTemplateDetails[]) => getTemplateDetails[];
}

const WhatsappTemplateProvider = ({ children }: ChildrenProps) => {
    const [templateList, setTemplateList] = useState<getTemplateDetails[] | null>(null);
    const [flagImportTemplatePopup, setFlagImportTemplatePopup] = useState<boolean>(false);
    const [showLegacyImportPopup , setShowLegacyImportPopup] = useState<boolean>(false);
    const [importLegacyTemplatePayload, setImportLegacyTemplatePayload] = useState<createWhatsappTemplatePayload | null>(null);
    const [importLegacyTemplateName, setImportLegacyTemplateName] = useState<string | null>(null);
    const [importLegacyTemplateJson, setImportLegacyTemplateJson] = useState<string | null>(null);
    const [importLegacyTemplateFile, setImportLegacyTemplateFile] = useState<File | null>(null);
    const [importLegacyTemplateFileName, setImportLegacyTemplateFileName] = useState<string | null>(null);
    const [importLegacyTemplateSelectedTab, setImportLegacyTemplateSelectedTab] = useState<number>(0);

    const getTemplateList = async (meta_integration_whatsapp_id: number) => {
        const response = await agent.getWhatsappTemplateList.get(meta_integration_whatsapp_id)
        if (response.status) {
            setTemplateList(response.data)
        } 
        else {
            setTemplateList(null)
        }
        return response
    }

    const sortTemplateList = (templateList: getTemplateDetails[]) => {
        return templateList?.sort((a, b) => {
            const aTimeStamp = a?.updated_at_timestamp ?? 0;
            const bTimeStamp = b?.updated_at_timestamp ?? 0;

            return new Date(bTimeStamp).getTime() - new Date(aTimeStamp).getTime();
        });
    }

    const payload = {
        templateList,
        setTemplateList,
        getTemplateList,

        flagImportTemplatePopup,
        setFlagImportTemplatePopup,
        showLegacyImportPopup ,
        setShowLegacyImportPopup ,

        importLegacyTemplatePayload,
        setImportLegacyTemplatePayload,
        importLegacyTemplateName,
        setImportLegacyTemplateName,
        importLegacyTemplateJson,
        setImportLegacyTemplateJson,
        importLegacyTemplateFile,
        setImportLegacyTemplateFile,
        importLegacyTemplateFileName,
        setImportLegacyTemplateFileName,
        importLegacyTemplateSelectedTab,
        setImportLegacyTemplateSelectedTab,

        sortTemplateList
    };

    return (
        <WhatsappTemplateContext.Provider value={payload}>
            {children}
        </WhatsappTemplateContext.Provider>
    );
};

export { WhatsappTemplateContext, WhatsappTemplateProvider };
